import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

import store from './store';
import { userLoggedIn, loginAction } from './actions/authActions';
import { getUserInfoById } from './services/authService';
import { User } from './types/models/user';

import App from './app';

if (localStorage.authInfo) {
  try {
    const info: User = JSON.parse(localStorage.authInfo);
    store.dispatch(userLoggedIn(info));
  } catch {
    localStorage.removeItem('authInfo');
  }
}

if (window.__loginSessionId) {
  getUserInfoById(window.__loginSessionId).then(([error, res]) => {
    if (error || !res || !res.data) {
      alert('Failed to get user information');
      window.location.replace('/');
      return;
    }

    const data: any = res.data;

    if (data.error) {
      alert(data.message);
      window.location.replace('/');
      return;
    }

    const responseData: any = data.data || data;

    if (responseData.sessionId) {
      const userInfo: User = {
        sessionId: responseData.sessionId,
        name: responseData.name || responseData.client?.fullName || null,
        email: responseData.email || responseData.client?.email || '',
      };
      store.dispatch(loginAction(userInfo));
    }

    window.location.replace('/');
  });
}

const container = document.getElementById('reactor');

if (!container) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);
